import { render, staticRenderFns } from "./EnablePartnerSearch.vue?vue&type=template&id=45907c64"
import script from "./EnablePartnerSearch.vue?vue&type=script&lang=js"
export * from "./EnablePartnerSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports